import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ListaComponent as SeguridadLista } from './components/seguridad/usuarios/lista/lista.component';
import { SolicitudContratistaListaComponent } from './components/solicitudes/contratista/solicitud-contratista-lista/solicitud-contratista-lista.component';
import { SolicitudContratistaCompletarComponent } from './components/solicitudes/contratista/solicitud-contratista-completar/solicitud-contratista-completar.component';
import { SolicitudEngieListaComponent } from './components/solicitudes/engie/solicitud-engie-lista/solicitud-engie-lista.component';
import { SolicitudEngieRegistrarComponent } from './components/solicitudes/engie/solicitud-engie-registrar/solicitud-engie-registrar.component';
import { LoginComponent } from './components/seguridad/login/login.component';
import { RecuperarContrasenaComponent } from './components/seguridad/recuperar-contrasena/recuperar-contrasena.component';
import { RestablecerContrasenaComponent } from './components/seguridad/restablecer-contrasena/restablecer-contrasena.component';
import { CambiarContrasenaComponent } from './components/seguridad/cambiar-contrasena/cambiar-contrasena.component';
import { SolicitudEditarComponent } from './components/solicitudes/engie/solicitud-editar/solicitud-editar.component';
import { SolicitudValidarComponent } from './components/solicitudes/validar/solicitud-validar/solicitud-validar.component';
import { ConfiguracionContratistaListaComponent } from './components/configuracion/contratista/configuracion-contratista-lista/configuracion-contratista-lista.component';
import { ConfiguracionContratistaEditarComponent } from './components/configuracion/contratista/configuracion-contratista-editar/configuracion-contratista-editar.component';
import { ConfiguracionContratistaRegistrarComponent } from './components/configuracion/contratista/configuracion-contratista-registrar/configuracion-contratista-registrar.component';
import { ConfiguracionSedeListarComponent } from './components/configuracion/sede/configuracion-sede-listar/configuracion-sede-listar.component';
import { ConfiguracionSedeRegistrarComponent } from './components/configuracion/sede/configuracion-sede-registrar/configuracion-sede-registrar.component';
import { ConfiguracionSedeEditarComponent } from './components/configuracion/sede/configuracion-sede-editar/configuracion-sede-editar.component';
import { ConfiguracionTipoVisitaListarComponent } from './components/configuracion/tipo-visita/configuracion-tipo-visita-listar/configuracion-tipo-visita-listar.component';
import { ConfiguracionTipoVisitaRegistrarComponent } from './components/configuracion/tipo-visita/configuracion-tipo-visita-registrar/configuracion-tipo-visita-registrar.component';
import { ConfiguracionTipoVisitaEditarComponent } from './components/configuracion/tipo-visita/configuracion-tipo-visita-editar/configuracion-tipo-visita-editar.component';
import { ConfiguracionDocumentoListarComponent } from './components/configuracion/documento/configuracion-documento-listar/configuracion-documento-listar.component';
import { ConfiguracionDocumentoRegistrarComponent } from './components/configuracion/documento/configuracion-documento-registrar/configuracion-documento-registrar.component';
import { ConfiguracionDocumentoEditarComponent } from './components/configuracion/documento/configuracion-documento-editar/configuracion-documento-editar.component';
import { InduccionProgramacionListaComponent } from './components/induccion/induccion-programacion-lista/induccion-programacion-lista.component';
import { InduccionListaComponent } from './components/induccion/induccion-lista/induccion-lista.component';

import { InduccionRegistroResultadosListaComponent } from './components/induccion/induccion-registro-resultados-lista/induccion-registro-resultados-lista/induccion-registro-resultados-lista.component';
import { AccesoPersonalComponent } from './components/accesos/acceso-personal/acceso-personal.component';
import { AuthGuard } from './auth.guard';
import { SolicitudAprobacionComponent } from './components/solicitudes/solicitud-aprobacion/solicitud-aprobacion.component';
import { SolicitudesBandejaRevisorComponent } from './components/solicitudes/solicitudes-bandeja-revisor/solicitudes-bandeja-revisor.component';
import { SolicitudesBandejaSupervisorComponent } from './components/solicitudes/solicitudes-bandeja-supervisor/solicitudes-bandeja-supervisor.component';
import { SolicitudRevisorValidarComponent } from './components/solicitudes/solicitud-revisor-validar/solicitud-revisor-validar.component';
import { ValidarVigenciaComponent } from './components/accesos/validar-vigencia/validar-vigencia.component';
import { VigilanteAccesosListaComponent } from './components/vigilante/vigilante-accesos-lista/vigilante-accesos-lista.component';
import { DeshabilitarAccesosPersonalComponent } from './components/accesos/deshabilitar-accesos-personal/deshabilitar-accesos-personal.component';
import { AccesosPorVencerListaComponent } from './components/accesos/accesos-por-vencer-lista/accesos-por-vencer-lista.component';
import { SolicitudContratistaDocumentoPorVencerListaComponent } from './components/solicitudes/contratista/solicitud-contratista-documento-por-vencer-lista/solicitud-contratista-documento-por-vencer-lista.component';
import { SolicitudValidarRenovacionDocumentosListaComponent } from './components/solicitudes/solicitud-validar-renovacion-documentos-lista/solicitud-validar-renovacion-documentos-lista.component';
import { SolicitudPendienteAccesoListaComponent } from './components/solicitudes/solicitud-pendiente-acceso-lista/solicitud-pendiente-acceso-lista.component';
import { AccesoPersonalContratistaListaComponent } from './components/accesos/acceso-personal-contratista-lista/acceso-personal-contratista-lista.component';
import { MaestroDocumentoListarComponent } from './components/configuracion/maestro-documento/maestro-documento-listar/maestro-documento-listar.component';
import { MaestroDocumentoRegistrarComponent } from './components/configuracion/maestro-documento/maestro-documento-registrar/maestro-documento-registrar.component';
import { MaestroDocumentoEditarComponent } from './components/configuracion/maestro-documento/maestro-documento-editar/maestro-documento-editar.component';
import { SolicitudDetalleComponent } from './components/solicitudes/solicitud-detalle/solicitud-detalle.component';
import { OktaAuthGuard } from './OktaAuthGuard .guard';
import { CallbackComponent } from './components/callback/callback.component';
import { Rol } from './models/role/role';
import { AccesoDenegadoComponent } from './components/acceso-denegado/acceso-denegado.component';
import { InduccionPersonasListaComponent } from './components/induccion/induccion-personas-lista/induccion-personas-lista.component';
import { SolicitudContratistaRegistrarComponent } from './components/solicitudes/contratista/solicitud-contratista-registrar/solicitud-contratista-registrar.component';
import { ListanegraListaComponent } from './components/listanegra/listanegra-lista/listanegra-lista.component';
import { ListaNegraModel } from './models/listanegra/ListaNegraModel';
import { ListanegraRegistrarComponent } from './components/listanegra/listanegra-registrar/listanegra-registrar.component';
import { SsoCalendarioListarComponent } from './components/informacionsso/calendario/sso-calendario-listar/sso-calendario-listar.component';
import { SsoCalendarioRegistrarComponent } from './components/informacionsso/calendario/sso-calendario-registrar/sso-calendario-registrar.component';
import { SsoContratistaListarComponent } from './components/informacionsso/contratista/sso-contratista-listar/sso-contratista-listar.component';
import { PasstSeguimientoListarComponent } from './components/passt/passt-seguimiento-listar/passt-seguimiento-listar.component';
import { SsoEngieListarComponent } from './components/informacionsso/engie/sso-engie-listar/sso-engie-listar.component';
import { SsoAmpliacionBandejaAprobacionComponent } from './components/informacionsso/ampliacion/sso-ampliacion-bandeja-aprobacion/sso-ampliacion-bandeja-aprobacion.component';
import { HiposSeguimientoListarComponent } from './components/hipos/hipos-seguimiento-listar/hipos-seguimiento-listar.component';
import { HiposSeguimientoRegistrarComponent } from './components/hipos/hipos-seguimiento-registrar/hipos-seguimiento-registrar.component';
import { PasstPlanificacionCargaComponent } from './components/passt/passt-planificacion-carga/passt-planificacion-carga.component';
import { ConfiguracionProyectoListarComponent } from './components/configuracion/proyecto/configuracion-proyecto-listar/configuracion-proyecto-listar.component';
import { ConfiguracionProyectoRegistrarComponent } from './components/configuracion/proyecto/configuracion-proyecto-registrar/configuracion-proyecto-registrar.component';
import { ConfiguracionProyectoEditarComponent } from './components/configuracion/proyecto/configuracion-proyecto-editar/configuracion-proyecto-editar.component';
import { ConfiguracionGbuListarComponent } from './components/configuracion/gbu/configuracion-gbu-listar/configuracion-gbu-listar.component';
import { ConfiguracionGbuRegistrarComponent } from './components/configuracion/gbu/configuracion-gbu-registrar/configuracion-gbu-registrar.component';
import { ConfiguracionGbuEditarComponent } from './components/configuracion/gbu/configuracion-gbu-editar/configuracion-gbu-editar.component';
import { ConfiguracionTipoReglaEditarComponent } from './components/configuracion/tipo-regla/configuracion-tipo-regla-editar/configuracion-tipo-regla-editar.component';
import { ConfiguracionTipoReglaListarComponent } from './components/configuracion/tipo-regla/configuracion-tipo-regla-listar/configuracion-tipo-regla-listar.component';
import { ConfiguracionTipoReglaRegistrarComponent } from './components/configuracion/tipo-regla/configuracion-tipo-regla-registrar/configuracion-tipo-regla-registrar.component';
import { ConfiguracionTipoEmpleadoEditarComponent } from './components/configuracion/tipo-empleado/configuracion-tipo-empleado-editar/configuracion-tipo-empleado-editar.component';
import { ConfiguracionTipoEmpleadoListarComponent } from './components/configuracion/tipo-empleado/configuracion-tipo-empleado-listar/configuracion-tipo-empleado-listar.component';
import { ConfiguracionTipoEmpleadoRegistrarComponent } from './components/configuracion/tipo-empleado/configuracion-tipo-empleado-registrar/configuracion-tipo-empleado-registrar.component';
import { ConfiguracionActoCondicionEditarComponent } from './components/configuracion/acto-condicion/configuracion-acto-condicion-editar/configuracion-acto-condicion-editar.component';
import { ConfiguracionActoCondicionListarComponent } from './components/configuracion/acto-condicion/configuracion-acto-condicion-listar/configuracion-acto-condicion-listar.component';
import { ConfiguracionActoCondicionRegistrarComponent } from './components/configuracion/acto-condicion/configuracion-acto-condicion-registrar/configuracion-acto-condicion-registrar.component';
import { ConfiguracionCategoriaHipoEditarComponent } from './components/configuracion/categoria-hipo/configuracion-categoria-hipo-editar/configuracion-categoria-hipo-editar.component';
import { ConfiguracionCategoriaHipoListarComponent } from './components/configuracion/categoria-hipo/configuracion-categoria-hipo-listar/configuracion-categoria-hipo-listar.component';
import { ConfiguracionCategoriaHipoRegistrarComponent } from './components/configuracion/categoria-hipo/configuracion-categoria-hipo-registrar/configuracion-categoria-hipo-registrar.component';
import { SsoAmpliacionHistorialSolicitudesComponent } from './components/informacionsso/ampliacion/sso-ampliacion-historial-solicitudes/sso-ampliacion-historial-solicitudes.component';
import { HiposSeguimientoEditarComponent } from './components/hipos/hipos-seguimiento-editar/hipos-seguimiento-editar.component';
import { ConfiguracionTipoAccidenteEditarComponent } from './components/configuracion/tipo-accidente/configuracion-tipo-accidente-editar/configuracion-tipo-accidente-editar.component';
import { ConfiguracionTipoAccidenteListarComponent } from './components/configuracion/tipo-accidente/configuracion-tipo-accidente-listar/configuracion-tipo-accidente-listar.component';
import { ConfiguracionTipoAccidenteRegistrarComponent } from './components/configuracion/tipo-accidente/configuracion-tipo-accidente-registrar/configuracion-tipo-accidente-registrar.component';
import { PasstRotuloEditarComponent } from './components/passt/passt-rotulo-editar/passt-rotulo-editar.component';
import { SolicitudesBandejaAdminComponent } from './components/solicitudes/solicitudes-bandeja-admin/solicitudes-bandeja-admin.component';
import { ParametrosConfiguracionListarComponent } from './components/configuracion/parametros/parametros-configuracion-listar/parametros-configuracion-listar.component';
import { ParametrosConfiguracionEditarComponent } from './components/configuracion/parametros/parametros-configuracion-editar/parametros-configuracion-editar.component';
import { ConfiguracionCompaniaListaComponent } from './components/configuracion/compania/configuracion-compania-lista/configuracion-compania-lista.component';
import { ConfiguracionCompaniaRegistrarComponent } from './components/configuracion/compania/configuracion-compania-registrar/configuracion-compania-registrar.component';
import { ConfiguracionCompaniaEditarComponent } from './components/configuracion/compania/configuracion-compania-editar/configuracion-compania-editar.component';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard],
    data: { roles: [ Rol.Administrador, Rol.Contratista, Rol.CoordinadorSSO, Rol.Revisor, Rol.Solicitante, Rol.Supervisor, Rol.Vigilante, Rol.ResponsableHIPO, Rol.AdministradorSSO ]}
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  { path: 'login', component: LoginComponent },
  { path: 'acceso-denegado', component: AccesoDenegadoComponent, canActivate: [AuthGuard] },
  { path: 'recuperar-contrasena', component: RecuperarContrasenaComponent },
  // { path: 'restablecer-contrasena/:id', component: RestablecerContrasenaComponent },
  
  {
    path: 'account',
    children: [
      // { path: '', redirectTo: '/login', pathMatch: 'full' },
      { path: ':id/restablecer-contrasena', component: RestablecerContrasenaComponent },
    ]
  },

  {
    path: 'solicitudes-engie',
    children: [
      { path: '', component: SolicitudEngieListaComponent },
      { path: 'registrar', component: SolicitudEngieRegistrarComponent },
    ], canActivate: [AuthGuard],
    data: { roles: [ Rol.Solicitante ]}
  },
  {
    path: 'solicitudes-contratista',
    children: [
      { path: '', component: SolicitudContratistaListaComponent },
      { path: 'documentos-por-vencer', component: SolicitudContratistaDocumentoPorVencerListaComponent },
      { path: 'registrar', component: SolicitudContratistaRegistrarComponent },
    ], 
    canActivate: [AuthGuard],
    data: { roles: [ Rol.Contratista ]}
  },
  {
    path: 'solicitudes',
    children: [
      { path: 'revision', component: SolicitudesBandejaRevisorComponent },
      { path: 'aprobacion', children: [
        { path: '', component: SolicitudesBandejaSupervisorComponent },      
        { path: ':id/detalle', component: SolicitudDetalleComponent },
      ]},  
      { path: 'administracion', children: [
        { path: '', component: SolicitudesBandejaAdminComponent },      
        { path: ':id/detalle', component: SolicitudDetalleComponent },
      ]},  
      { path: 'contratista', children: [
        { path: ':id/detalle', component: SolicitudDetalleComponent },
      ]},      
      { path: 'validar-renovacion-documentos', component: SolicitudValidarRenovacionDocumentosListaComponent },
      { path: 'pendientes-acceso', component: SolicitudPendienteAccesoListaComponent },      
      { path: ':id', component: SolicitudEditarComponent },
      {
        path: ':id/completar',
        component: SolicitudContratistaCompletarComponent,
      },
      { path: ':id/validar', component: SolicitudValidarComponent },
      { path: ':id/revisor', children:[
        {path: 'validar', component: SolicitudRevisorValidarComponent}
      ]},
      { path: ':id/aprobacion', component: SolicitudAprobacionComponent },
      { path: ':id/detalle', component: SolicitudDetalleComponent },
    ],
    canActivate: [AuthGuard],
    data: { roles: [ Rol.Solicitante, Rol.Contratista, Rol.Supervisor, Rol.Revisor, Rol.Administrador, Rol.AdministradorSSO ]}
  },
  {
    path: 'inducciones',
    children: [
      { path: '', component: InduccionListaComponent },
      { path: 'programacion', component: InduccionProgramacionListaComponent },
      { path: 'personas', component: InduccionPersonasListaComponent },
      {
        path: 'resultados',
        children: [
          {
            path: 'registrar',
            component: InduccionRegistroResultadosListaComponent,
          },
        ],
      },
    ],
    canActivate: [AuthGuard],
    data: { roles: [ Rol.CoordinadorSSO, Rol.Contratista, Rol.Solicitante, Rol.Supervisor, Rol.Vigilante ]}
  },
  {
    path: 'seguridad',
    children: [
      { path: '', component: SeguridadLista },
      { path: 'cambiar-contrasena', component: CambiarContrasenaComponent },
      // { path: 'registrar', component: SolicitudRegistrar },
    ],
    canActivate: [AuthGuard],
    data: { roles: [ Rol.Administrador, Rol.Contratista ]}
  },
  {
    path: 'configuracion',
    children: [
      {
        path: 'contratistas',
        children: [
          { path: '', component: ConfiguracionContratistaListaComponent },
          {
            path: 'registrar',
            component: ConfiguracionContratistaRegistrarComponent,
          },
          { path: ':id', component: ConfiguracionContratistaEditarComponent },
        ],
      },
      {
        path: 'companias',
        children: [
          { path: '', component: ConfiguracionCompaniaListaComponent },
          {
            path: 'registrar',
            component: ConfiguracionCompaniaRegistrarComponent,
          },
          { path: ':id', component: ConfiguracionCompaniaEditarComponent },
        ],
      },
      {
        path: 'sedes',
        children: [
          { path: '', component: ConfiguracionSedeListarComponent },
          { path: 'registrar', component: ConfiguracionSedeRegistrarComponent },
          { path: ':id', component: ConfiguracionSedeEditarComponent },
        ],
      },
      {
        path: 'tipo-visitas',
        children: [
          { path: '', component: ConfiguracionTipoVisitaListarComponent },
          {
            path: 'registrar',
            component: ConfiguracionTipoVisitaRegistrarComponent,
          },
          { path: ':id', component: ConfiguracionTipoVisitaEditarComponent },
        ],
      },
      {
        path: 'maestro-documentos',
        children: [
          { path: '', component: MaestroDocumentoListarComponent },
          {
            path: 'registrar',
            component: MaestroDocumentoRegistrarComponent,
          },
          { path: ':id', component: MaestroDocumentoEditarComponent },
        ],
      },
      {
        path: 'documentos',
        children: [
          { path: '', component: ConfiguracionDocumentoListarComponent },
          {
            path: 'registrar',
            component: ConfiguracionDocumentoRegistrarComponent,
          },
          { path: ':id', component: ConfiguracionDocumentoEditarComponent },
        ],
      },
      {
        path: 'proyectos',
        children: [
          { path: '', component: ConfiguracionProyectoListarComponent },
          { path: 'registrar', component: ConfiguracionProyectoRegistrarComponent },
          { path: ':id', component: ConfiguracionProyectoEditarComponent },
        ],
      },
      {
        path: 'gbu',
        children: [
          { path: '', component: ConfiguracionGbuListarComponent },
          { path: 'registrar', component: ConfiguracionGbuRegistrarComponent },
          { path: ':id', component: ConfiguracionGbuEditarComponent },
        ],
      },
      {
        path: 'tipo-reglas',
        children: [
          { path: '', component: ConfiguracionTipoReglaListarComponent },
          { path: 'registrar', component: ConfiguracionTipoReglaRegistrarComponent },
          { path: ':id', component: ConfiguracionTipoReglaEditarComponent },
        ],
      },
      {
        path: 'tipo-empleados',
        children: [
          { path: '', component: ConfiguracionTipoEmpleadoListarComponent },
          { path: 'registrar', component: ConfiguracionTipoEmpleadoRegistrarComponent },
          { path: ':id', component: ConfiguracionTipoEmpleadoEditarComponent },
        ],
      },
      {
        path: 'categorias-hipo',
        children: [
          { path: '', component: ConfiguracionCategoriaHipoListarComponent },
          { path: 'registrar', component: ConfiguracionCategoriaHipoRegistrarComponent },
          { path: ':id', component: ConfiguracionCategoriaHipoEditarComponent },
        ],
      },
      {
        path: 'actos-condicion',
        children: [
          { path: '', component: ConfiguracionActoCondicionListarComponent },
          { path: 'registrar', component: ConfiguracionActoCondicionRegistrarComponent },
          { path: ':id', component: ConfiguracionActoCondicionEditarComponent },
        ],
      },
      {
        path: 'tipo-accidentes',
        children: [
          { path: '', component: ConfiguracionTipoAccidenteListarComponent },
          { path: 'registrar', component: ConfiguracionTipoAccidenteRegistrarComponent },
          { path: ':id', component: ConfiguracionTipoAccidenteEditarComponent },
        ],
      },
      {
        path: 'parametros-configuracion',
        children: [
          { path: '', component: ParametrosConfiguracionListarComponent },
          { path: ':idMaestro/item/:id', component: ParametrosConfiguracionEditarComponent },
        ],
      },
    ],
    canActivate: [AuthGuard],
    data: { roles: [ Rol.Administrador ]}
  },
  {
    path: 'acceso-personal', 
    children: [
      { path: 'gestion', component: DeshabilitarAccesosPersonalComponent },
      { path: 'por-vencer', component: AccesosPorVencerListaComponent },
      { path: 'por-contratista', component: AccesoPersonalContratistaListaComponent },
      { path: ':id', component: AccesoPersonalComponent },      
    ]
    , canActivate: [AuthGuard],
    data: { roles: [ Rol.Supervisor, Rol.Contratista, Rol.Solicitante, Rol.CoordinadorSSO, Rol.Vigilante ]}
  },
  {
    path: 'vigilancia', 
    children: [
      { path: 'accesos', component: VigilanteAccesosListaComponent } 
    ]
    , canActivate: [AuthGuard],
    data: { roles: [ Rol.Vigilante, Rol.Supervisor, Rol.Solicitante, Rol.CoordinadorSSO ]}
  },
  {
    path: 'listanegra', 
    children: [
      { path: '', component: ListanegraListaComponent },
      {
        path: 'registrar',
        component: ListanegraRegistrarComponent,
      },
    ],
    canActivate: [AuthGuard],
    data: { roles: [Rol.Supervisor]}
  },
  {
    path: 'validar-vigencia', 
    children: [
      {
        path: ':id',
        component: ValidarVigenciaComponent,
      }
    ]
  },
  {
    path: 'sso', 
    children: [
      { path: 'calendario', component: SsoCalendarioListarComponent },
      {
        path: 'aprobar-solicitudes',
        component: SsoAmpliacionBandejaAprobacionComponent,
      },
      {
        path: 'historial-solicitudes',
        component: SsoAmpliacionHistorialSolicitudesComponent,
      }
    ],
    canActivate: [AuthGuard],
    data: { roles: [Rol.AdministradorSSO]}
  },
  {
    path: 'sso-contratista', 
    children: [
      { path: 'seguimiento', component: SsoContratistaListarComponent }
    ],
    canActivate: [AuthGuard],
    data: { roles: [Rol.Contratista]}
  },
  {
    path: 'sso-engie', 
    children: [
      { path: 'seguimiento', component: SsoEngieListarComponent }
    ],
    canActivate: [AuthGuard],
    data: { roles: [Rol.AdministradorSSO, Rol.CoordinadorSSO]}
  },
  {
    path: 'passt', 
    children: [
      { path: 'seguimiento', component: PasstSeguimientoListarComponent },
      { path: 'programacion', component: PasstPlanificacionCargaComponent },
      { path: ':id/rotulo', component: PasstRotuloEditarComponent }
    ],
    canActivate: [AuthGuard],
    data: { roles: [Rol.AdministradorSSO, Rol.CoordinadorSSO]}
  },
  {
    path: 'hipos', 
    children: [
      { path: '', component: HiposSeguimientoListarComponent },
      {
        path: 'registrar',
        component: HiposSeguimientoRegistrarComponent,
      },
      { path: ':id', component: HiposSeguimientoEditarComponent },
    ],
    canActivate: [AuthGuard],
    data: { roles: [Rol.AdministradorSSO, Rol.ResponsableHIPO]}
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
